import * as THREE from 'three';
import {
  BuildTree, KDTree, Node, EuclideanSearch, SearchNode,
} from './KDTree';
import { ClosePath } from '../objects';

export default class NotSamePointFloor {
    // 部屋の保持
    // private points: THREE.Vector2[] = [];
    private rooms: ClosePath[] = [];

    // treeの保持
    private tree: SearchNode;

    // 差分デフォルトの値
    private distance: number = 100;

    constructor() {
      // this.points = [];
      this.rooms = [];
      this.distance = 100;
      this.tree = null;
    }

    // 部屋登録
    public addRoom(closePath: ClosePath): void {
      this.rooms.push(closePath);
    }

    // tree作成
    public create(): boolean {
      if (!this.rooms.length) {
        console.warn('aaaaaaa');
        return false;
      }

      const kdtree = new BuildTree();

      this.rooms.forEach((room: ClosePath, roomIndex) => {
        room.position.forEach((point: THREE.Vector2) => {
          kdtree.add(new Node(point));
        });
      });

      this.tree = kdtree.buildTree();
      return true;
    }

    // 一致する頂点の探索
    public search(pos: THREE.Vector2): boolean {
      const search = new KDTree();
      return search.searchDist(this.tree, pos, this.distance).length == 0;
    }

    // 距離を設定する
    public setDistance(distance: number): void {
      if (distance <= 0) {
        console.warn('distance error !!!!');
      }
      this.distance = distance;
    }
}
